import { render, staticRenderFns } from "./dates-prices-list.vue?vue&type=template&id=6e88b198"
import script from "./dates-prices-list.vue?vue&type=script&lang=js"
export * from "./dates-prices-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports